import React, { useContext, useEffect, useState } from 'react';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import { Add, Category, Delete, Save } from '@mui/icons-material';
import { LoginContext } from '../../../App';
import LabelTranslated from '../../b2b-languages/components/LabelTranslated';
import { handleObjectFieldChange } from '../../b2b-common/helpers';
import { deleteCategory, saveNewCategory, updateCategory } from '../../../services/b2b-indicators-apiService';
import { updateObjectFieldsWithLabels } from '../../b2b-languages/components/helper';
import B2BPaper from '../../b2b-common/B2BPaper';

import './CategoryModal.css';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';

const CategoryModal = ({ open, toChangeCategory = null, onUpdate, onClose }) => {

    const { loginData } = useContext(LoginContext);
    const emptyCategory = {
        "measurementUnitCategoryId": null,
        "measurementUnitCategoryName": null,
        "measurementUnitCategoryDescription": null,
        "units": null,
    };
    const [category, setCategory] = useState(toChangeCategory ? toChangeCategory : emptyCategory);

    useEffect(() => {
        setCategory(toChangeCategory ? toChangeCategory : emptyCategory);
    }, [toChangeCategory]);

    const handleSaveNewCategory = async () => {
        //console.log('Saving new category:', category);
        try {
            const updatedCategory = updateObjectFieldsWithLabels(category);
            await saveNewCategory(updatedCategory, loginData.accessToken);
            onUpdate();
        } catch (error) {
            console.error('Error saving new category:', error);
        }
    }

    const handleUpdateCategory = async () => {
        //console.log('Updating category:', category);
        try {
            const updatedCategory = updateObjectFieldsWithLabels(category);
            await updateCategory(updatedCategory, loginData.accessToken);
            onUpdate();
        } catch (error) {
            console.error('Error updating category:', error);
        }
    }

    const handleDeleteCategory = async () => {
        //console.log('Deleting category:', category);
        try {
            await deleteCategory(category, loginData.accessToken);
            onUpdate();
        } catch (error) {
            console.error('Error deleting category:', error);
        }
    }

    const buttonsNewCategory = [
        {
            label: 'Save new category',
            confirm: true,
            onConfirm: handleSaveNewCategory,
            icon: <Add />
        },
    ];

    const buttonsUpdateCategory = [
        {
            label: 'Update category',
            confirm: true,
            onConfirm: handleUpdateCategory,
            icon: <Save />
        },
        {
            label: 'Delete category',
            confirm: true,
            onConfirm: handleDeleteCategory,
            icon: <Delete />
        },
    ];

    const headers = [
        { label: 'Unit', align: 'center' },
        { label: 'Unit name', align: 'left' },
    ];

    const rows = category.units && category.units.length > 0 ? category.units.map((unit) => ({
        id: unit.quantitativeMeasurementUnitId,
        cells: [
            { content: `${unit.quantitativeMeasurementUnit}`, align: 'center' },
            { content: `${unit.quantitativeMeasurementUnitName}`, align: 'left' },
        ]
    })) : [];

    //console.log('toChangeCategory: ', toChangeCategory);
    //console.log('category: ', category);

    return (
        <B2BPopUpForm
            open={open}
            icon={<Category />}
            title={toChangeCategory ? toChangeCategory.measurementUnitCategoryName : 'New category'}
            className={'b2b-category-modal'}
            onClose={onClose}
            buttons={toChangeCategory ? buttonsUpdateCategory : buttonsNewCategory}
        >
            <B2BPaper title='Fields' elevation={0} className='category-fields'>
                <LabelTranslated
                    key={`category-name-${category.measurementUnitCategoryId || 'new'}`}
                    field="Name"
                    labelValue={category.measurementUnitCategoryName_label}
                    onChange={(e) => handleObjectFieldChange('measurementUnitCategoryName_label', e.target.value, setCategory)}
                    locale={`Name [${loginData.locale}] `}
                    translation={category.measurementUnitCategoryName}
                />
                <LabelTranslated
                    key={`category-description-${category.measurementUnitCategoryId || 'new'}`}
                    field="Description"
                    labelValue={category.measurementUnitCategoryDescription_label}
                    onChange={(e) => handleObjectFieldChange('measurementUnitCategoryDescription_label', e.target.value, setCategory)}
                    locale={`Description [${loginData.locale}] `}
                    translation={category.measurementUnitCategoryDescription}
                    rowsNumber={4}
                />
            </B2BPaper>
            {category.units && category.units.length > 0 && (
                <B2BPaper title='Units' elevation={0} className='category-units'>
                    <B2BTableInMemory
                        headers={headers}
                        rows={rows}
                        className={"category-units-table"}
                        numRows={5}
                    />
                </B2BPaper>
            )}
        </B2BPopUpForm>
    );
};

export default CategoryModal;